import React from 'react';
import breakpoints from './breakpoints';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

export default class Breadcrumb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLarge: false,
      attachUrl : '',
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    const hrefUrl = window.location.href;
    if(hrefUrl.indexOf('?locale.x') !== -1){
      this.setState({
        attachUrl : hrefUrl.split('?')[1]
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (window.innerWidth > breakpoints.medium) {
      this.setState({
        isLarge: true,
      });
    }else {
      this.setState({
        isLarge: false,
      });
    }
  }

  handleClick() {
    window.history.back();
  }

  render() {
    const getBreadCrumbContent = getContent('staticContent');
    const {breadCrumbs} = this.props.articleInfo;
    const newBreadCrumbs = breadCrumbs.filter(breadCrumb => breadCrumb.id !== 'brc');
    const country  = (this.props.country).toLowerCase();
    const {attachUrl} = this.state;
    const fontChange = country === 'vn' && this.props.locale === 'vi_VN' ? 'vnFont' : country === 'jp' && this.props.locale === 'ja_JP'? 'jpFont': '';
    if(this.state.isLarge) {
      return(
        <div id = "breadcrumbContainer" className="articleBreadCrumbContainer">
        <div>
          {this.props.isHomeBreadcrumbEnabled ? <a data-pa-click={'brcBreadcrumbClick|BRC'} className = {`category ${fontChange}`} href = {attachUrl.length>0 ? `/${country}/brc/?${attachUrl}` : `/${country}/brc/`} >{getBreadCrumbContent('brc.breadCrumb')}</a> : null}
          {newBreadCrumbs && newBreadCrumbs.map(function (cat, index) {
            if(cat.title){
            return(
            <a data-pa-click={`brcBreadcrumbClick|${cat.title}`} className = {`category ${fontChange}`} href ={attachUrl.length>0 ? `/${country}/brc/topics/${cat.id}?${attachUrl}` :`/${country}/brc/topics/${cat.id}`} key={index}>{cat.title}</a>
            );}
          })}
        </div>
        </div>
      );
    }else{
      const breadCrumb = newBreadCrumbs[newBreadCrumbs.length - 1];
      return(
        <div id = "breadcrumbContainer" className="articleBreadCrumbContainer">
          <div>
            <div onClick={(e) => this.handleClick(e)} className = "vx_icon vx_icon-small vx_icon-arrow-back-small" />
              <a data-pa-click={`brcBreadcrumbClick|${breadCrumb.title}`} className ={`category ${fontChange}`}  href ={attachUrl.length>0 ? `/${country}/brc/topics/${breadCrumb.id}?${attachUrl}` : `/${country}/brc/topics/${breadCrumb.id}`}>{breadCrumb.title}</a>
          </div>
        </div>

      );
    }
  }
}

Breadcrumb.propTypes = {
  articleInfo: PropTypes.shape({
    breadCrumbs: PropTypes.array
  }),
  country: PropTypes.string,
  isHomeBreadcrumbEnabled: PropTypes.bool
};
